import { University } from "@/store/types/universityTypes";
import axiosInstance from "@/utils/axiosInstance";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { startLoading, stopLoading } from "../loader/loaderSlice";

export const getUniversityDetail = createAsyncThunk<
  University,
  number | string | string[]
>(
  "university/getCountryList",
  async (universityId, { rejectWithValue, dispatch }) => {
    dispatch(startLoading());
    try {
      const res = await axiosInstance.get(`/university/${universityId}`);
      dispatch(stopLoading());
      return res.data;
    } catch (e) {
      dispatch(stopLoading());
      return rejectWithValue(e);
    }
  }
);
